// extracted by mini-css-extract-plugin
export default {"root":"StackModal_root__VsI2q"};